import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { reApi, errMsg, fmtDateTime } from "@/lib/residentApi";
import { inputCls, labelCls, GoldButton, Pill, ErrorLine, EditToggle } from "./ui";

export default function PhaseTab({ resident, onChanged }) {
  const [data, setData] = useState({ history: [], phases: [] });
  const [toPhase, setToPhase] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);

  const load = () => reApi.get("/phase-history", { resident_id: resident.id }).then(setData).catch((e) => setError(errMsg(e)));
  useEffect(() => { load(); }, [resident.id, resident.current_phase]); // eslint-disable-line react-hooks/exhaustive-deps

  const move = async () => {
    setError(null);
    try { await reApi.post("/phase-history", { resident_id: resident.id, to_phase: toPhase, reason: reason || null }); setReason(""); setToPhase(""); setEditing(false); onChanged(); }
    catch (e) { setError(errMsg(e)); }
  };
  const others = data.phases.filter((p) => p !== resident.current_phase);

  return (
    <div data-testid="phase-tab" className="space-y-5">
      <EditToggle editing={editing} setEditing={setEditing} label="Edit phase" testId="phase" />
      <div className="p-3 border border-white/10 rounded-sm space-y-2">
        <div className={labelCls}>Current phase · <span data-testid="phase-current" className="text-nex-gold">Phase {resident.current_phase}</span></div>
        {editing && <><div className="grid sm:grid-cols-[160px_1fr_auto] gap-2">
          <select data-testid="phase-input-to" value={toPhase} onChange={(e) => setToPhase(e.target.value)} className={inputCls}>
            <option value="">Move to…</option>
            {others.map((p) => <option key={p} value={p}>{`Phase ${p}`}</option>)}
          </select>
          <input data-testid="phase-input-reason" value={reason} placeholder="Reason (optional)" onChange={(e) => setReason(e.target.value)} className={inputCls} />
          <GoldButton data-testid="phase-submit" onClick={move} disabled={!toPhase}>Record transition</GoldButton>
        </div>
        <ErrorLine testId="phase-error">{error}</ErrorLine>
        <p className="text-[11px] text-nex-muted">Every phase change is kept in the history below.</p></>}
      </div>
      <ol className="relative border-l border-nex-gold/30 ml-2 space-y-4">
        {data.history.map((h) => (
          <li key={h.id} data-testid={`phase-entry-${h.id}`} className="ml-4">
            <span className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full bg-nex-gold/80" />
            <div className="flex items-center gap-2 text-sm text-nex-silver">
              {h.from_phase ? <><Pill tone="dim">Phase {h.from_phase}</Pill><ArrowRight className="h-3 w-3 text-nex-muted" /></> : null}
              <Pill>Phase {h.to_phase}</Pill>
            </div>
            <div className="text-[11px] text-nex-muted mt-1">{fmtDateTime(h.changed_at)} · {h.changed_by?.name || h.changed_by?.email || "—"}</div>
            {h.reason && <div className="text-sm text-nex-silver/80 mt-0.5">{h.reason}</div>}
          </li>
        ))}
      </ol>
    </div>
  );
}
